<template>
  <form class="form" method="put">

    <div id="appClientEditVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <button @click.prevent="historyClient()" type="submit" class="appButtonModel2">Historique client</button>
        <br>
        <br>
        <h2>Modifier mon client</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Sexe*</p>
            <p class="appLabelStyle1">Nom*</p>
            <p class="appLabelStyle1">Prénom*</p>
            <p class="appLabelStyle1">Naissance</p>
            <p class="appLabelStyle1">Adresse</p>
            <p class="appLabelStyle1">Code postal</p>
            <p class="appLabelStyle1">Ville</p>
            <p class="appLabelStyle1">Téléphone</p>
            <p class="appLabelStyle1">Email</p>
            <p class="appLabelStyle1">Notes</p>
          </div>
          <div class="appGroupOfInput">
            <select v-model="client.sexe" type="string" name="sexe" class="appInputStyle1">
              <option valeur="femme">Femme</option>
              <option valeur="homme">Homme</option>
            </select>
            <input v-model="client.firstname" type="string" name="firstname" class="appInputStyle1">
            <input v-model="client.lastname" type="string" name="lastname" class="appInputStyle1">
            <input v-model="client.birthdate" type="date" name="birthdate" class="appInputStyle1">
            <input v-model="client.address" type="string" name="address" class="appInputStyle2">
            <input v-model="client.cp" type="string" name="cp" class="appInputStyle1">
            <input v-model="client.city" type="string" name="City" class="appInputStyle1">
            <input v-model="client.phone" type="string" name="phone" class="appInputStyle1">
            <input v-model="client.mail" type="mail" name="mail" class="appInputStyle2">
            <input v-model="client.notes" type="string" name="notes" class="appInputStyle1">
          </div>
        </div>
      </div>
      <button @click.prevent="modifyClient()" type="submit" class="appButtonModel2">Corriger mon client</button>
      <br>
      <div class="appGroupOfDivCreateOrModify">
        <h2>Ajouter une fiche technique</h2>
        <div class="appGroupOfDivNamesAndInput">
          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Date</p>
            <p class="appLabelStyle1">Technique</p>
          </div>
          <div class="appGroupOfInput">
            <input id="clientTechnicalDate" type="date" name="birthdate" class="appInputStyle1">
            <input id="clientTechnicalText" type="string" name="notes" class="appInputStyle1">
          </div>
          <br>
        </div>
        <button @click.prevent="addTechnical()" type="submit" class="appButtonModel2">Ajouter ma fiche technique</button>
      </div>
      <br>
      <button @click.prevent="deleteClient()" type="submit" class="appButtonModel2">Supprimer mon client</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

  </form>
</template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'ClientEdit',
  data () {
    return {
      sexe: '',
      firstname: '',
      lastname: '',
      birthdate: '',
      address: '',
      cp: '',
      city: '',
      phone: '',
      mail: '',
      notes: '',
      datesOfVisits: [],
      TechnicalsDatas: [],
      errorMsg: '',
      client: ''
    }
  },
  mounted () {
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/clients/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.client = response.data
      })
  },
  methods: {
    historyClient () {
      const url = document.location.href
      const idToUse = url.substring(url.lastIndexOf('=') + 1)
      this.$router.push('/App/Clients/Historique?id=' + idToUse)
    },
    modifyClient () {
      // Test si champs remplis
      if (this.sexe !== null || this.firstname !== null || this.lastname !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage + ID client
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        const url = document.location.href
        const idToModify = url.substring(url.lastIndexOf('=') + 1)
        axios
          .put('https://privilegia.fr/api/clients/' + idToModify,
            {
              'userId': decryptedToken.userId,
              'sexe': this.client.sexe,
              'firstname': this.client.firstname.toUpperCase(),
              'lastname': this.client.lastname,
              'birthdate': this.client.birthdate,
              'address': this.client.address,
              'cp': this.client.cp,
              'city': this.client.city,
              'phone': this.client.phone,
              'mail': this.client.mail,
              'notes': this.client.notes,
              'technicalsDatas': this.client.technicalsDatas
            }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
          .then((response) => {
            window.alert('Données client modifiées')
            this.$router.push('/App/Clients')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
        // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner au minimum le sexe, nom et prénom'
      }
    },
    deleteClient () {
      if (window.confirm('Supprimer ce client ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const url = document.location.href
        const idToDelete = url.substring(url.lastIndexOf('=') + 1)
        axios
          .delete('https://privilegia.fr/api/clients/' + idToDelete,
            { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Client supprimé')
            this.$router.push('/App/Clients')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      } else {
      }
    },
    addTechnical () {
      let myDate = document.getElementById('clientTechnicalDate').value
      let myTexte = document.getElementById('clientTechnicalText').value
      if (!myDate) {
        alert('Pas de date renseignée')
      } else {
        if (!myTexte) {
          alert('Pas de texte renseigné')
        } else {
          const cartTechnical =
            {
              date: myDate,
              text: myTexte,
              invoiceId: '-',
              invoiceNumber: '-'
            }
          const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
          const url = document.location.href
          const idToModify = url.substring(url.lastIndexOf('=') + 1)
          axios
            .get(('https://privilegia.fr/api/clients/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
            .then((response) => {
              this.client = response.data
              let arrayOfTechnical = this.client.technicalsDatas
              arrayOfTechnical.push(cartTechnical)
              axios
                .put('https://privilegia.fr/api/clients/' + idToModify,
                  {
                    'technicalsDatas': arrayOfTechnical
                  }, {headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' }})
                .then((response) => {
                  window.alert('Fiche technique ajoutée')
                })
                .catch((error) => {
                  console.log(error.response.data)
                })
            })
        }
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppClientsEdit.vue